import React, { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSupplierRetailer } from "./SupplierRetailerContext";
import { usePageAccess } from "./PageAccessContext";

const AuthContext = createContext();

export const useAuthentication = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user_type, setUserType] = useState(null);
  const navigate = useNavigate();
  const { resetContext: resetSupplierRetailerContext } = useSupplierRetailer();
  const { resetContext: resetPageAccessContext } = usePageAccess();

  const signIn = (user_type = null) => {
    setIsAuthenticated(true);
    if (user_type !== null) {
      setUserType(user_type);
      localStorage.setItem("user_type", user_type);
    }
  };

  const signOut = async () => {
    // Revoke the refresh token server-side so it can't be replayed if the
    // device is shared. Best-effort — never block sign-out on a network call.
    const refreshToken = localStorage.getItem("refreshToken");
    if (refreshToken) {
      try {
        await axios.post(`${process.env.REACT_APP_API_URL}/login/sign-out`, { refreshToken });
      } catch (e) {
        // ignore — local clear is what matters
      }
    }
    setIsAuthenticated(false);
    setUserType(null);
    resetSupplierRetailerContext();
    resetPageAccessContext();
    localStorage.clear();
    navigate("/signin");
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user_type, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
};